import React, { useEffect, useState } from 'react';
import { Sparkles, Users, MailCheck, CalendarCheck, PhoneCall, Clock } from 'lucide-react';
import api from '../../lib/api';

// Tiny "today" proof-of-work ticker — shows what the autonomous engine did today.
const ITEMS = [
  { key: 'prospected', icon: Users, label: 'prospected', color: 'text-emerald-500' },
  { key: 'replies_sent', icon: MailCheck, label: 'replies sent', color: 'text-blue-500' },
  { key: 'booked', icon: CalendarCheck, label: 'booked', color: 'text-violet-500' },
  { key: 'callbacks', icon: PhoneCall, label: 'callbacks', color: 'text-cyan-500' },
  { key: 'snoozed', icon: Clock, label: 'snoozed', color: 'text-amber-500' },
];

export const AutonomyTicker = () => {
  const [today, setToday] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get('/api/brain/autonomy-ticker')
      .then((r) => { if (alive) setToday(r.data?.today || null); })
      .catch(() => { if (alive) setToday(null); });
    return () => { alive = false; };
  }, []);

  if (!today) return null;
  const total = (today.prospected || 0) + (today.replies_sent || 0) + (today.booked || 0) + (today.callbacks || 0);
  // Show even at zero snoozed if there's activity; hide entirely if nothing at all.
  if (total === 0 && (today.snoozed || 0) === 0) return null;

  return (
    <div
      data-testid="autonomy-ticker"
      className="mx-auto mb-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 rounded-full border border-border/50 bg-card/50 backdrop-blur-sm px-4 py-2 text-xs w-fit"
    >
      <span className="inline-flex items-center gap-1.5 font-medium text-foreground">
        <Sparkles className="h-3.5 w-3.5 text-indigo-400" /> Today
      </span>
      {ITEMS.map(({ key, icon: Icon, label, color }) => (
        <span key={key} className="inline-flex items-center gap-1 text-muted-foreground" data-testid={`ticker-${key}`}>
          <Icon className={`h-3.5 w-3.5 ${color}`} />
          <strong className="text-foreground tabular-nums">{today[key] || 0}</strong> {label}
        </span>
      ))}
    </div>
  );
};

export default AutonomyTicker;
